<template>
  <div v-if="taxRate" class="ta-auction-hammer-tax-rate">
    <label v-if="label === true" class="ta-auction-hammer-tax-rate-label">{{ $t('VAT On Hammer') }} &nbsp;</label>
    <label v-else-if="label"  class="ta-auction-hammer-tax-rate-label">{{ label }}</label>
    <span class="ta-auction-hammer-tax-rate-value">{{ taxRate }}%</span>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "HammerTaxRate",
  props: {
    label: {
      type: [Boolean, String],
      default: true
    },
    auction: {
      required: false,
      type: [Object, Boolean],
      default: () => false
    },
  },
  computed: {
    ...mapState({auctionVuex: state => state.auctionObject.data}),
    auctionObj() {
      return this.auction || this.auctionVuex
    },
    taxRate() {
      let rate = parseFloat(this.auctionObj.hammer_tax_rate)
      if (parseInt(this.auctionObj.hammer_tax_rate) < rate) {
        return rate.toFixed(1)
      }
      return rate;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
